var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import Chip from "@mui/material/Chip";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import "../styles/CreatedArts.css";
import ModalDeleteArt from "./ModalDeleteArt";
function CreatedArts(_a) {
    var arts = _a.arts, onDelete = _a.onDelete, products = _a.products, images = _a.images, onSelect = _a.onSelect;
    var _b = useState(null), artToDelete = _b[0], setArtToDelete = _b[1];
    var _c = useState(false), showAll = _c[0], setShowAll = _c[1];
    var _d = useState(false), shouldShowButton = _d[0], setShouldShowButton = _d[1];
    var _e = useState(), collapsedHeight = _e[0], setCollapsedHeight = _e[1];
    var containerRef = useRef(null);
    var prod_url = process.env.REACT_APP_STORAGE_URL;
    useEffect(function () {
        var container = containerRef.current;
        if (!container)
            return;
        var measure = function () {
            var children = Array.from(container.children);
            if (!children.length)
                return;
            var firstRowTop = children[0].offsetTop;
            var moreThanOneRow = children.some(function (el) { return el.offsetTop !== firstRowTop; });
            setShouldShowButton(moreThanOneRow);
            // altura da primeira linha (maior card dessa linha) + folga para a sombra
            var firstRow = children.filter(function (el) { return el.offsetTop === firstRowTop; });
            setCollapsedHeight(Math.max.apply(Math, firstRow.map(function (el) { return el.offsetHeight; })) + 12);
        };
        measure();
        // re-mede quando o container ou os cards mudam de tamanho (ex.: imagens carregando)
        var ro = new ResizeObserver(measure);
        ro.observe(container);
        Array.from(container.children).forEach(function (c) { return ro.observe(c); });
        window.addEventListener("resize", measure);
        return function () {
            ro.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, [arts]);
    function getProductName(productId) {
        var product = products.find(function (p) { return String(p.id) === productId; });
        return product ? product.name : productId;
    }
    ;
    function getImageUrl(imageId) {
        if (!imageId)
            return null;
        var image = images.find(function (img) { return String(img.id) === String(imageId); });
        if (!(image === null || image === void 0 ? void 0 : image.path))
            return null;
        return "".concat(prod_url, "/").concat(image.path);
    }
    function confirmDelete() {
        if (artToDelete) {
            onDelete(artToDelete);
            setArtToDelete(null);
        }
    }
    ;
    return (_jsxs("div", __assign({ className: "created-arts-wrapper" }, { children: [_jsx("div", __assign({ className: "created-arts-header" }, { children: shouldShowButton && (_jsx("button", __assign({ type: "button", className: "show-more-button", onClick: function () { return setShowAll(!showAll); } }, { children: showAll ? "Ver menos" : "Ver mais" }))) })), _jsx("div", __assign({ className: "created-arts-container ".concat(shouldShowButton && !showAll ? "collapsed" : "expanded"), ref: containerRef, style: { maxHeight: shouldShowButton && !showAll ? collapsedHeight : undefined } }, { children: arts.map(function (art) {
                    var _a;
                    var imageUrl = getImageUrl(art.imageId);
                    return (_jsxs("div", __assign({ className: "created-art-box ".concat(art.format === 'landscape' ? 'landscape' : 'portrait') }, { children: [_jsx("button", { type: "button", className: "created-art-box-select", "aria-label": art.name ? "Selecionar arte ".concat(art.name) : 'Selecionar arte', onClick: function () { return onSelect === null || onSelect === void 0 ? void 0 : onSelect(art); } }), _jsxs("div", __assign({ className: "created-art-box-image-preview" }, { children: [imageUrl ? (_jsx("img", { src: imageUrl, alt: "Preview da arte" })) : (_jsx(InsertPhotoOutlinedIcon, {})), _jsx("button", __assign({ type: "button", className: "delete-button", onClick: function (e) {
                                            e.stopPropagation();
                                            setArtToDelete(art.id);
                                        } }, { children: _jsx(DeleteIcon, { fontSize: "small" }) }))] })), _jsxs("div", __assign({ className: "created-art-box-infos" }, { children: [_jsx("p", { children: art.date }), _jsx("p", __assign({ className: "created-art-box-title" }, { children: art.name })), _jsx("div", __assign({ className: "created-art-box-products" }, { children: ((_a = art.products) !== null && _a !== void 0 ? _a : []).map(function (productId) { return (_jsx(Chip, { label: getProductName(productId), className: "chip-product-name" }, productId)); }) }))] }))] }), art.id));
                }) })), _jsx(ModalDeleteArt, { show: !!artToDelete, closeModal: function () { return setArtToDelete(null); }, onConfirm: confirmDelete })] })));
}
export default CreatedArts;
